// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-fork-me-on-github img {\n  position: absolute;\n  top: 0;\n  right: 0;\n  border: 0;\n  width: 150px;\n  z-index: 10000;\n}", ""]);
// Exports
module.exports = exports;
